import { useRouter } from 'next/router'
import React, { useCallback, useEffect, useMemo, useState } from 'react'

import { COOKIES } from '../../constants'
import { createCookie, readCookie } from '../../helpers'
import Meta from '../../components/Meta'
import { useTranslation } from '../../contexts/I18nContext'
import { COLORS } from '../../styles'

import Styled from './ErrorPage.styled'

const Egg = ({ width = 751, height = 660, type = 404 }) => {
  return (
    <Styled.illustration
      width={width}
      height={height}
      viewBox="0 0 751 660"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M362.026 39.9509C424.168 45.2841 462.69 106.4 516.244 138.75C568.157 170.109 634.659 177.188 670.576 226.334C710.703 281.239 738.031 353.265 721.243 419.251C704.654 484.456 642.326 525.482 585.511 560.689C537.023 590.735 480.218 592.2 424.349 603.227C361.864 615.559 300.901 647.03 239.747 628.931C170.377 608.402 107.385 562.445 71.8156 498.894C34.5072 432.235 22.4743 350.577 42.72 276.908C62.3014 205.656 119.757 153.565 178.751 109.785C232.665 69.7756 295.271 34.2217 362.026 39.9509Z"
        fill={COLORS.white}
      />
      <path
        d="M479.136 342.076C446.758 400.208 376.063 433.96 316.538 389.423C247.855 338.034 238.813 284.388 271.191 226.257C303.513 168.224 376.117 147 433.493 178.746C433.689 178.854 433.877 178.981 434.051 179.12C487.695 222.227 511.461 284.039 479.136 342.076Z"
        fill={COLORS.yolk}
      />
      {type === 404 && (
        <>
          <path
            d="M231.023 377.284C231.875 379.322 230.913 381.665 228.875 382.517L207.762 391.342C205.724 392.194 204.762 394.537 205.614 396.575L218.048 426.322C218.9 428.36 217.938 430.703 215.9 431.555L202.774 437.041C200.736 437.893 198.393 436.932 197.541 434.893L185.108 405.146C184.256 403.108 181.913 402.146 179.874 402.998L109.33 432.485C107.292 433.337 104.949 432.375 104.097 430.337L99.8052 420.07C99.4915 419.319 99.414 418.491 99.5832 417.695L125.992 293.501C126.265 292.217 127.151 291.149 128.362 290.643L142.913 284.561C145.89 283.316 149.04 285.928 148.368 289.084L125.372 397.169C124.7 400.325 127.85 402.936 130.827 401.692L172.978 384.073C175.017 383.221 175.978 380.878 175.126 378.84L164.858 354.274C164.006 352.236 164.968 349.893 167.006 349.041L179.268 343.915C181.307 343.064 183.65 344.025 184.502 346.063L194.77 370.63C195.622 372.668 197.965 373.63 200.003 372.778L221.115 363.953C223.154 363.101 225.497 364.063 226.349 366.101L231.023 377.284Z"
            fill={COLORS.black}
          />
          <path
            d="M639.493 458.579C638.846 460.691 636.609 461.879 634.496 461.232L612.617 454.53C610.505 453.883 608.268 455.071 607.621 457.183L598.179 488.01C597.532 490.123 595.295 491.31 593.183 490.663L579.58 486.497C577.468 485.85 576.28 483.613 576.927 481.501L586.37 450.674C587.017 448.562 585.829 446.325 583.717 445.678L510.61 423.285C508.498 422.638 507.31 420.401 507.957 418.289L511.216 407.649C511.454 406.871 511.924 406.185 512.563 405.681L612.231 327.019C613.262 326.206 614.626 325.95 615.881 326.335L630.961 330.954C634.046 331.899 634.8 335.92 632.267 337.918L545.515 406.369C542.982 408.367 543.737 412.389 546.822 413.334L590.504 426.714C592.616 427.361 594.853 426.173 595.5 424.06L603.298 398.602C603.945 396.49 606.182 395.302 608.294 395.949L621.002 399.841C623.114 400.488 624.302 402.725 623.655 404.837L615.857 430.296C615.21 432.408 616.398 434.645 618.51 435.292L640.389 441.994C642.501 442.641 643.689 444.877 643.042 446.99L639.493 458.579Z"
            fill={COLORS.black}
          />
        </>
      )}
      {type === 500 && (
        <>
          <path
            d="M118.2,314c22-9.4,39.8-12.3,53.5-8.8c13.8,3.4,23.7,12.1,29.6,25.9c3.7,8.7,4.9,17.6,3.6,26.5
		c-1.3,8.7-5.5,17-12.6,24.9c-7,7.8-16.8,14.4-29.5,19.9c-11.1,4.8-22.4,7.7-33.7,8.9c-10,0.9-19.1,0.4-27.3-1.6
		c-1.9-0.5-3.1-2.3-2.9-4.2l1.6-12.8c0.3-2.5,2.8-4.1,5.2-3.5c6.4,1.4,13.4,1.9,21,1.3c9.5-0.7,18.9-3.1,28.2-7.1
		c11.7-5,19.7-11.2,24-18.8c4.4-7.6,4.9-15.4,1.4-23.6c-3.7-8.7-10.1-13.9-19.1-15.4c-9-1.6-22.1,1.2-39.2,8.5l-31.9,13.6
		c-2.2,0.9-4.7-0.2-5.4-2.5L62,272.1c-0.6-2,0.4-4.1,2.2-4.9l79.9-34.1c2-0.9,4.4,0.1,5.2,2.1l4.7,11c0.9,2-0.1,4.4-2.1,5.2
		l-62.2,26.5c-1.9,0.8-2.9,2.9-2.2,4.9l10.9,34.7c0.7,2.3,3.2,3.4,5.4,2.5L118.2,314z"
            fill={COLORS.black}
          />
          <path
            d="M500.8,423.4c-7.6-9.1-12.4-20.4-14.3-33.9c-1.9-13.5-0.4-28.4,4.5-44.8s11.8-29.6,20.8-39.9
			s19.1-17.1,30.5-20.5c11.3-3.4,23.1-3.3,35.3,0.3c12,3.6,21.9,9.9,29.5,19s12.4,20.4,14.3,33.9c1.9,13.5,0.4,28.4-4.5,44.8
			c-4.9,16.3-11.8,29.6-20.8,39.9c-9,10.3-19.2,17.1-30.5,20.5s-23,3.3-35.1-0.3C518.3,438.9,508.4,432.5,500.8,423.4z M570.6,416.5
			c10.4-7.9,18.5-21.5,24.3-40.8c5.7-19.2,6.4-35,2-47.4c-4.4-12.4-12.8-20.4-25.1-24.1c-12.5-3.7-24-1.6-34.4,6.3
			s-18.5,21.5-24.3,40.8c-5.7,19.3-6.4,35-2,47.4s12.8,20.4,25.3,24.1C548.7,426.6,560.1,424.4,570.6,416.5z"
            fill={COLORS.black}
          />
        </>
      )}
    </Styled.illustration>
  )
}

const ErrorPage = ({ statusCode }) => {
  const { t } = useTranslation()
  const { asPath } = useRouter()

  const decodedUrl = useMemo(() => {
    if (asPath) {
      try {
        return decodeURIComponent(asPath)
      } catch (e) {
        return ''
      }
    }
    return ''
  }, [asPath])
  const [displayRetry, setDisplayRetry] = useState(false)
  useEffect(() => {
    const retried = readCookie(COOKIES.RETRIED_PAGES.name)
    if (
      +statusCode === 404 &&
      decodedUrl &&
      decodedUrl !== asPath &&
      decodedUrl.includes('?') &&
      (!retried || (retried && !JSON.parse(retried).includes(decodedUrl)))
    ) {
      setDisplayRetry(true)
    } else {
      setDisplayRetry(false)
    }
  }, [decodedUrl, statusCode, asPath])

  const handleCookie = useCallback(
    (url) => () => {
      const retried = readCookie(COOKIES.RETRIED_PAGES.name)
      if (retried) {
        const cookieValue = JSON.parse(retried)
        createCookie(
          COOKIES.RETRIED_PAGES.name,
          JSON.stringify(cookieValue.concat(url)),
          COOKIES.RETRIED_PAGES.maxAge,
        )
      } else {
        createCookie(
          COOKIES.RETRIED_PAGES.name,
          JSON.stringify([url]),
          COOKIES.RETRIED_PAGES.maxAge,
        )
      }
    },
    [],
  )

  return (
    <>
      <Meta
        title={
          statusCode
            ? statusCode === 404
              ? t('ERROR.PAGE_NOT_FOUND')
              : `${t('ERROR.ERROR')} ${statusCode}`
            : t('ERROR.ERROR')
        }
      >
        <meta name="robots" content="noindex, follow" />
        <meta name="googlebot" content="noindex" />
      </Meta>
      <Styled>
        <Styled.content>
          {(() => {
            switch (+statusCode) {
              case 404:
                return (
                  <Styled.notFount>
                    <Styled.lottieContainer>
                      <Styled.lottie
                        animationName="404-egg"
                        title="loader"
                        options={{ loop: false, autoplay: true }}
                        width="100%"
                        heigth="100%"
                        id="404"
                        fallback={<Egg type={404} />}
                      />
                      <Styled.label>
                        {t('ERROR.OOPS')}
                        <br />
                        {t('ERROR.NO_CONTENT')}
                      </Styled.label>
                    </Styled.lottieContainer>
                  </Styled.notFount>
                )
              case 500:
                return (
                  <Styled.serverError>
                    <Styled.lottieContainer>
                      <Styled.lottie
                        animationName="500-egg"
                        title="loader"
                        options={{ loop: false, autoplay: true }}
                        width="100%"
                        heigth="100%"
                        id="500"
                        fallback={<Egg type={500} />}
                      />
                      <Styled.label>
                        {t('ERROR.OOPS')}
                        <br />
                        {t('ERROR.SERVER_ERROR')}
                      </Styled.label>
                    </Styled.lottieContainer>
                    <Styled.fix>{t('ERROR.FIX_IT')}</Styled.fix>
                  </Styled.serverError>
                )
              default:
                return (
                  <Styled.genericError>
                    <Styled.lottieContainer>
                      <Styled.lottie
                        animationName="error-egg"
                        title="loader"
                        options={{ loop: false, autoplay: true }}
                        width="100%"
                        heigth="100%"
                        id="error"
                        fallback={<Egg type="error" />}
                      />
                      <Styled.label>
                        {t('ERROR.OOPS')}
                        <br />
                        {t('ERROR.GENERIC_ERROR')}
                      </Styled.label>
                    </Styled.lottieContainer>
                    <Styled.fix>{t('ERROR.FIX_IT')}</Styled.fix>
                  </Styled.genericError>
                )
            }
          })()}

          {displayRetry && (
            <Styled.retry>
              <Styled.retryText>
                {t('ERROR.RETRY')}
                <br />
                &laquo;
                <Styled.retryLink
                  to={decodedUrl}
                  onClick={handleCookie(decodedUrl)}
                >
                  {decodedUrl}
                </Styled.retryLink>
                &raquo;
              </Styled.retryText>
            </Styled.retry>
          )}

          <Styled.goBack>
            <Styled.goBackLink to="/">{t('ERROR.GO_HOME')}</Styled.goBackLink>
          </Styled.goBack>
        </Styled.content>
      </Styled>
    </>
  )
}

ErrorPage.defaultProps = {
  statusCode: 404,
}

export default ErrorPage
